import Repository from "./Repository";

const resource = "/Banners";
import store from "../store";
export default {
  list() {
    return Repository.get(`${resource}/list`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  create(item) {
    return Repository.post(`${resource}`, item, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        store.commit("setSnack", {
          message: "Изменения сохранены",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  get(id) {
    return Repository.get(`${resource}/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  update(item) {
    return Repository.patch(`${resource}`, item, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        store.commit("setSnack", {
          message: "Изменения сохранены",
          color: "success",
        });
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
